import { useEffect, useState } from 'react'

import { Cookie, setCookie, getCookie } from '@lib/utils/cookies'

const isShMailExtensionInstalled = (): boolean =>
  IS_CLIENT_SIDE && window?.document?.documentElement.classList.contains('superhumanIsInstalled')

const persistInstallation = (isInstalled: boolean) => {
  setCookie(Cookie.ShMailExtensionInstalled, isInstalled)
}

/**
 * This is a workaround used by ATC / Nomos Portal to tell if Mail Extension is installed.
 * Currently, SH Mail does not inject "superhumanIsInstalled" on Nomos Portal subdomain. Once this is fixed,
 * we can remove this hook.
 *
 * Refer to: https://grammarly.slack.com/archives/C093WL0S1L0/p1761598937858419?thread_ts=1761086611.468989&cid=C093WL0S1L0
 */

export const usePersistMailExtension = (): { isMailExtensionInstalled: boolean } => {
  const [isMailExtensionInstalled, setIsMailExtensionInstalled] = useState(false)

  useEffect(() => {
    setIsMailExtensionInstalled(isShMailExtensionInstalled())
  }, [])

  useEffect(() => {
    try {
      const isInstalledCookieStr: string | undefined = getCookie(Cookie.ShMailExtensionInstalled)
      const isInstalledCookie = isInstalledCookieStr ? JSON.parse(isInstalledCookieStr) : false
      if (
        (!isInstalledCookieStr && isMailExtensionInstalled) ||
        (isInstalledCookieStr && isInstalledCookie !== isMailExtensionInstalled)
      ) {
        persistInstallation(isMailExtensionInstalled)
      }
    } catch {
      persistInstallation(isMailExtensionInstalled)
    }
  }, [isMailExtensionInstalled])

  return { isMailExtensionInstalled }
}
